module.exports = __webpack_public_path__ + "16ac93783e0fcdea3086fe89a081144e.svg";